import request from '@/utils/request'

// 活动列表
export const list = (params) =>
  request({
    url: '/api/backend/activity/index',
    method: 'GET',
    params,
  })

// 添加活动
export const addEvent = (body) =>
  request({
    url: '/api/backend/activity/add',
    method: 'POST',
    data: {
      ...body,
    },
  })

// 上下架
export const changeState = (id) =>
  request({
    url: '/api/backend/activity/state',
    method: 'POST',
    data: {
      id,
    },
  })

// 活动删除
export const delEvent = (id) =>
  request({
    url: '/api/backend/activity/del',
    method: 'POST',
    data: {
      id,
    },
  })

export const cancel = (id) =>
  request({
    url: '/api/backend/activity/suspend',
    method: 'POST',
    data: { id },
  })

export const registryList = (params) =>
  request({
    url: '/api/backend/activity/user/list',
    method: 'GET',
    params,
  })
//一键发放积分
export const registryBatchSignIn = (data) =>
  request({
    url: '/api/backend/activity/batch/grant',
    method: 'POST',
    data,
  })
// 批量驳回
export const registryBatchExamine = (data) =>
  request({
    url: '/api/backend/activity/batch/examine',
    method: 'POST',
    data,
  })
// 通过审核
export const registryExamine = (data) =>
  request({
    url: '/api/backend/activity/examine',
    method: 'POST',
    data,
  })
// 签到
export const signIn = (data) =>
  request({
    url: '/api/backend/activity/sign/in',
    method: 'POST',
    data,
  })
// 发放积分
export const grant = (data) =>
  request({
    url: '/api/backend/activity/grant',
    method: 'POST',
    data,
  })
// 发放积分
export const exportActivityExcel = (params) =>
  request({
    url: '/api/backend/excel/activity',
    method: 'GET',
    params,
  })
